import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=2e285eff&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"
import style0 from "./Customer.vue?vue&type=style&index=0&id=2e285eff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e285eff",
  null
  
)

component.options.__file = "Customer.vue"
export default component.exports